function showLine (f, v, s) {
  return (f.ignore == null || !f.ignore(v, s)) &&
    (f.hide == null || !f.hide(v, s))
}

export default {
  newTab: function (i, title) {
    return {
      id: `tab-${i}`,
      type: 'tab',
      parameters: title
    }
  },

  newTitle: function (i, title) {
    return {
      id: `title-${i}`,
      type: 'title-preview',
      show: true,
      parameters: title
    }
  },

  newRepeatableTitle: function (i, title, field, value, sheet) {
    return {
      id: `repeatable-title-${i}`,
      type: 'title-preview',
      show: showLine(field, value, sheet),
      parameters: title
    }
  },

  newField: function (vm, i, field, value, note, sheet) {
    const show = showLine(field, value, sheet)
    const context = show ? field.buildContext(sheet, sheet) : null
    return {
      id: `field-${i}`,
      type: 'field-preview',
      show: show,
      target: value,
      value: value[field.field],
      note: note,
      parameters: {
        config: field,
        context: context,
        indentation: 0,
        hint: vm.config.showHints && !vm.state.list,
        autoNext: vm.config.autoNext
      }
    }
  },

  newArray: function (indentation, i, k, field, item, value, sheet) {
    const index = parseInt(k, 10) + 1
    return {
      id: `array-${i}-${item.id}`,
      type: 'array-preview',
      show: showLine(field, value, sheet),
      parameters: {
        indentation: indentation,
        config: {
          text: `${field.config.title}${index}`,
          empty: item[field.config.fields[0].field] == null
        }
      }
    }
  },

  newSubfield: function (
    vm, indentation, field, item, k, subfield, show, note, sheet
  ) {
    const showSubfield = show && showLine(subfield, item, sheet)
    const context = showSubfield ? subfield.buildContext(item, sheet) : null
    return {
      id: `field-${field}-${item.id}-${k}-${subfield.field}`,
      type: 'field-preview',
      show: showSubfield,
      target: item,
      value: item[subfield.field],
      note: note,
      parameters: {
        config: subfield,
        context: context,
        indentation: indentation,
        hint: vm.config.showHints && !vm.state.list,
        autoNext: vm.config.autoNext
      }
    }
  }
}
